import type { StoreActionApi } from 'react-sweet-state';
import type { ConnectionProviders, State } from '../../../../common/types';

export const updateConnectionStatus =
    (provider: ConnectionProviders) =>
    ({ getState, setState }: StoreActionApi<State>) => {
        setState({
            ...getState(),
            connectionStatus: {
                ...getState().connectionStatus,
                data: {
                    ...getState().connectionStatus.data,
                    [provider]: {
                        ...getState().connectionStatus.data[provider],
                        isUserOAuthed: true,
                    },
                },
            },
        });
    };
